module.exports = __webpack_public_path__ + "static/media/super-jump.09de2ec7.jpg";